import React from "react";

function RotatingTool(props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.25065 18.4587L7.96732 17.1753L9.57148 15.5253C7.61593 15.2656 6.00412 14.7309 4.73607 13.9212C3.46801 13.1114 2.83398 12.1795 2.83398 11.1253C2.83398 9.85727 3.71628 8.77637 5.48086 7.88262C7.24544 6.98887 9.41871 6.54199 12.0007 6.54199C14.5826 6.54199 16.7559 6.98887 18.5204 7.88262C20.285 8.77637 21.1673 9.85727 21.1673 11.1253C21.1673 12.0725 20.6593 12.9205 19.6434 13.6691C18.6274 14.4177 17.302 14.9753 15.6673 15.342V13.4628C16.8437 13.1573 17.7489 12.7791 18.3829 12.3285C19.017 11.8778 19.334 11.4767 19.334 11.1253C19.334 10.6364 18.6809 10.0559 17.3746 9.38366C16.0684 8.71144 14.277 8.37533 12.0007 8.37533C9.72426 8.37533 7.93294 8.71144 6.62669 9.38366C5.32044 10.0559 4.66732 10.6364 4.66732 11.1253C4.66732 11.492 5.0569 11.9312 5.83607 12.443C6.61523 12.9548 7.72287 13.3406 9.15898 13.6003L7.96732 12.4087L9.25065 11.1253L12.9173 14.792L9.25065 18.4587Z"
        fill="#E8EAED"
      />
    </svg>
  );
}

export default RotatingTool;
